export function parseEmbedToMarkdown(data) {
  return `[${data.source}|${data.source}|smart-embed]\n`;
}